<div data-testId="tooltip-message" [innerHTML]="message"></div>
